<template>
	<div class="data42" :style="{
	 marginTop:list.is_top?'':'-149px'
 }">
		<!-- :style="{
 	backgroundImage:`url(${list.data.bg_cover})`,
 }" -->
		<div class="data16Bg" :style="{
				backgroundImage:`url('${list.data.bg_cover}')`,
			}">
			<div class="data16Img">
				<img :src="list.data.bg_cover1" v-if="list.data.bg_cover1" />
				<img src="@/assets/product/cgq/fd100.png" v-else />
			</div>
			<div class="data16Wz">
				<div class="data16WzTil">{{list.data.title}}</div>
				<div class="data16WzCen">{{list.data.desc}}</div>
			</div>
			<div class="data16BgSp">
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.videos" :key="index">
							<template v-if="headerShow">
								<video :src="item" :autoplay="true" muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
							</template>
							<template v-else>
								<video :src="item"  muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
							</template>
						</div>
					</div>
					<template v-if="!headerShow">
						<div class="swiper-hexin-prev"  :style="{
							left:`30px`,
							display:qhShow?activeIndex==0?'none':'block':'none'
						}" @click="prev()">
							<img src="@/assets/index/hxz.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:`30px`,
							display:qhShow?activeIndex==list.data.videos.length-1?'none':'block':'none'
						}" @click="next()">
							<img src="@/assets/index/hxy.png" />
						</div>
					</template>
				</div>
				<!-- <img src="@/assets/content/fd100img.png" /> -->
				<!-- <video></video> -->
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				img4kBj: require("@/assets/content/fd100.png"),
				qhShow:true,
				activeIndex: 0,
			}
		},
		mounted() {
			let t = this

			let name = '.swiper-data2-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				slidesPerView: 1,
				allowTouchMove: this.list.data.videos.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.videos.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.videos.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.videos.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data16Bg {
		width: 100%;
		height: 1700px;
		// margin-top: -200px;
		background-size: cover;
		background-position: top center;
		// background-attachment: fixed;
		display: flex;
		flex-direction: column;
		background-image: url("~@/assets/product/cgq/cp4kbg.png");
		background-repeat: repeat-y;
		min-width: 1200px;

		// margin-bottom:150px;
		.data16Img {
			width: 100%;
			max-width: 1920px;
			margin: 0 auto;
			height: 671px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.data16Wz {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: end;
			flex-direction: column;

			.data16WzTil {
				font-size: 45px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #FFFFFF;
				margin-bottom: 61px;
				width: 776px;
				text-align: center;
			}

			.data16WzCen {
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #FFFFFF;
				width: 776px;
				margin-bottom: 99px;
				text-align: center;
				white-space: pre-line;
			}
		}

		.data16BgSp {
			width: 1200px;
			height: 600px;
			margin: 0 auto;
			padding-bottom: 93px;

			img {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}

			video {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}
		}

	}

	.data42 {
		padding-bottom: 150px;
	}

	.swiper-data2-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}

	@media screen and (max-width:1200px) {
		.data42 {
			padding: 0px 0px 30px !important;
			margin-top: -30px !important;
		}
		.data16Bg {
			max-width: 100% !important;
			min-width: auto !important;
			height: auto !important;
			.data16Img{
				// padding-top: 30px !important;
				height: auto !important;
				img{
					height: auto !important;
					object-fit: contain !important;
				}
			}
			.data16Wz {
				.data16WzTil {
					font-size: 24px !important;
					margin-bottom: 20px !important;
					width: 100% !important;
				}
			
				.data16WzCen {
					font-size: 14px !important;
					width: 100% !important;
					margin-bottom: 20px !important;
					padding:0 30px !important;
					box-sizing: border-box;
				}
			}
			.data16BgSp {
				width: 100% !important;
				height: auto !important;
				padding-bottom: 0px !important;
			
				img {
					width: 100%;
					height: auto !important;
					object-fit: cover;
				}
			
				video {
					width: 100%;
					height: auto !important;
					object-fit: cover;
				}
			}
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>